const botanicheska302 = {
  "id": "botanicheska302",
  "title": "Botanicheska 302",
  "description": {
    "bg": "BOTANICHESKA 302 е нова жилищна сграда в Св. Св. Константин и Елена, съчетаваща модерна архитектура, панорамни апартаменти и изобилие от зеленина. Проектът е създаден с мисъл за бъдещето, като предлага живот в баланс между градската динамика и спокойствието на природата.\n\nСградата е проектирана като еко-приятелска и устойчива – с сертификация за зелена сграда.\n\nИнтериорът е разработен с дизайн за естествена вентилация, използване на устойчиви материали и енергийно ефективно осветление, осигурявайки комфорт, здравословна среда и високо качество на живот.\n\nBOTANICHESKA 302 е не просто жилище – това е интелигентен, стилен и устойчив дом, в който архитектура, екология и съвременен комфорт се срещат, за да предложат уникално преживяване и дългосрочна стойност.",
    "en": "BOTANICHESKA 302 is a new residential building in St. Constantine and Helena, combining modern architecture, panoramic apartments and abundant greenery. The project is designed with the future in mind, offering a life in balance between urban dynamics and the tranquility of nature.\n\nThe building is designed to be eco-friendly and sustainable – with green building certification.\n\nThe interior is developed with natural ventilation design, the use of sustainable materials and energy-efficient lighting, ensuring comfort, a healthy environment and a high quality of life.\n\nBOTANICHESKA 302 is not just a home – it is an intelligent, stylish and sustainable residence where architecture, ecology and modern comfort come together to offer a unique experience and long-term value.",
    "de": "BOTANICHESKA 302 ist ein neues Wohngebäude in St. Konstantin und Helena, das moderne Architektur, Panorama-Apartments und reichlich Grünflächen vereint. Das Projekt wurde mit Blick auf die Zukunft konzipiert und bietet ein Leben im Gleichgewicht zwischen urbaner Dynamik und der Ruhe der Natur.\n\nDas Gebäude ist als umweltfreundlich und nachhaltig konzipiert – mit Zertifizierung für ein grünes Gebäude.\n\nDas Interieur wurde mit einem Design für natürliche Belüftung, der Verwendung nachhaltiger Materialien und energieeffizienter Beleuchtung entwickelt, um Komfort, eine gesunde Umgebung und hohe Lebensqualität zu gewährleisten.\n\nBOTANICHESKA 302 ist nicht nur ein Zuhause – es ist ein intelligentes, stilvolles und nachhaltiges Domizil, in dem Architektur, Ökologie und moderner Komfort zusammenkommen, um ein einzigartiges Erlebnis und langfristigen Wert zu bieten.",
    "ru": "BOTANICHESKA 302 — это новое жилое здание в Св. Константин и Елена, сочетающее современную архитектуру, панорамные апартаменты и обилие зелени. Проект создан с мыслью о будущем, предлагая жизнь в балансе между городской динамикой и спокойствием природы.\n\nЗдание спроектировано как экологичное и устойчивое — с сертификацией зеленого здания.\n\nИнтерьер разработан с дизайном естественной вентиляции, использованием устойчивых материалов и энергоэффективным освещением, обеспечивая комфорт, здоровую среду и высокое качество жизни.\n\nBOTANICHESKA 302 — это не просто жилище, а интеллектуальный, стильный и устойчивый дом, в котором архитектура, экология и современный комфорт встречаются, чтобы предложить уникальный опыт и долгосрочную ценность."
  },
  "location": {
    "en": "St. Constantine and Helena, Varna",
    "bg": "Св. Константин и Елена, Варна",
    "de": "St. Konstantin und Helena, Varna",
    "ru": "Св. Константин и Елена, Варна"
  },
  "mapData": {
    "embedUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1495540.1207575295!2d24.33352481862508!3d42.93661599537169!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a457001435b1b7%3A0x82247c3c0d8a1500!2sBotanicheska%20302!5e0!3m2!1sen!2sbg!4v1759424967128!5m2!1sen!2sbg",
    "directionsUrl": "https://maps.app.goo.gl/jqGErVXiAk5gsKXw5",
    "coordinates": {
      "lat": 43.232952,
      "lng": 28.003764
    }
  },
  "type": "Eco-Residential Complex",
  "year": "2025",
  "status": "Act 14",
  "heroImage": "/projects/botanicheska302/IMG_4181.jpeg",
  "images": [
    "/projects/botanicheska302/IMG_4181.jpeg",
    "/projects/botanicheska302/IMG_4575.jpeg",
    "/projects/botanicheska302/IMG_5189.jpeg",
    "/projects/botanicheska302/IMG_7507.jpeg",
    "/projects/botanicheska302/IMG_8289.jpeg",
    "/projects/botanicheska302/IMG_9592.jpeg"
  ],
  "features": {
    "en": [
      "Eco-friendly construction",
      "Green building certification",
      "Solar panel integration",
      "Rainwater harvesting system",
      "Natural ventilation design",
      "Sustainable materials",
      "Green roof technology",
      "Energy-efficient lighting"
    ],
    "bg": [
      "Еко-приятелско строителство",
      "Сертификация за зелена сграда",
      "Интеграция на слънчеви панели",
      "Система за събиране на дъждовна вода",
      "Дизайн за естествена вентилация",
      "Устойчиви материали",
      "Технология за зелена покривка",
      "Енергийно ефективно осветление"
    ],
    "de": [
      "Umweltfreundliches Bauen",
      "Green Building Zertifizierung",
      "Solarpanel-Integration",
      "Regenwassersammelsystem",
      "Natürliche Belüftung",
      "Nachhaltige Materialien",
      "Gründach-Technologie",
      "Energieeffiziente Beleuchtung"
    ],
    "ru": [
      "Экологически чистое строительство",
      "Сертификация зеленого здания",
      "Интеграция солнечных панелей",
      "Система сбора дождевой воды",
      "Дизайн естественной вентиляции",
      "Устойчивые материалы",
      "Технология зеленой крыши",
      "Энергоэффективное освещение"
    ]
  },
  "stats": {
    "area": "3,200 m²",
    "floors": "6",
    "units": "50"
  },
  "freeApartments": {
    "bg": "15 свободни апартамента",
    "en": "15 free apartments",
    "de": "15 freie Wohnungen",
    "ru": "15 свободных квартир"
  },
  "availableApartments": 15
};

export default botanicheska302;
